import React, { Component, Fragment } from 'react';
import { Card, Row, Col } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class OrderBook extends Component {
    render() {
        const { orderbook, position, trades, instrument } = this.props.store.odysseyBotStore;

        if (!orderbook || !trades.length || !instrument || !instrument.last_price) return null;

        const lastTrade = trades[0];
        const buys = orderbook.filter(entry => entry.side === 'Buy').sort((a, b) => b.id - a.id);
        const sells = orderbook.filter(entry => entry.side === 'Sell').sort((a, b) => a.id - b.id);

        return (
            <Card
                title={'Orderbook'}
                extra={
                    <span>
                        <i className="fal fa-wallet" />{' '}
                        {(position && position.wallet_balance.toFixed(8)) || 0} BTC
                    </span>
                }
                bordered={false}
                style={{ marginBottom: 15, height: 435, overflow: 'hidden', overflowY: 'auto' }}
                bodyStyle={{ overflowY: 'auto', padding: 0 }}
            >
                <div
                    className={'orderbook-last'}
                    style={{ background: '#1c1e2f', padding: '10px 50px', textAlign: 'center' }}
                >
                    {this.renderTick(lastTrade.tick_direction, lastTrade.side)}
                    &nbsp;&nbsp;
                    <span className={lastTrade.side === 'Buy' ? 'success' : 'error'}>
                        {instrument.last_price}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <i className="fal fa-flag" /> {instrument.mark_price}
                </div>

                <Row gutter={24} style={{ padding: 25, fontSize: '0.9em' }}>
                    <Col xs={12}>
                        <div className={'orderbook-bids'}>
                            <Row>
                                {buys.map(entry => {
                                    return (
                                        <Fragment key={entry.id}>
                                            <Col sm={12}>
                                                {entry.size.toLocaleString(undefined, {
                                                    maximumFractionDigits: 2
                                                })}
                                            </Col>
                                            <Col sm={12}>
                                                <span className={'success'}>{entry.price}</span>
                                            </Col>
                                        </Fragment>
                                    );
                                })}
                            </Row>
                        </div>
                    </Col>

                    <Col xs={12}>
                        <div className={'orderbook-asks'}>
                            <Row>
                                {sells.map(entry => {
                                    return (
                                        <Fragment key={entry.id}>
                                            <Col sm={12}>
                                                <span className={'error'}>{entry.price}</span>
                                            </Col>
                                            <Col sm={12}>
                                                {entry.size.toLocaleString(undefined, {
                                                    maximumFractionDigits: 2
                                                })}
                                            </Col>
                                        </Fragment>
                                    );
                                })}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Card>
        );
    }

    renderTick(direction, side) {
        const cssClass = side === 'Buy' ? 'success' : 'error';

        if (direction === 'PlusTick') {
            return <i className={`fal fa-arrow-up ${cssClass}`} />;
        }
        if (direction === 'MinusTick') {
            return <i className={`fal fa-arrow-down ${cssClass}`} />;
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/TradeView/OrderBook.js